module.exports = __webpack_public_path__ + "static/media/agile2.0610a805.png";